import type { Rarity } from './constants'

import embuinImg from '@/assets/echoes/embuin.jpg'
import rumpuffImg from '@/assets/echoes/rumpuff.jpg'
import lebunyiImg from '@/assets/echoes/lebunyi.jpg'
import crikawnImg from '@/assets/echoes/crikawn.jpg'
import tikidewImg from '@/assets/echoes/tikidew.jpg'
import kelipsiImg from '@/assets/echoes/kelipsi.jpg'
import arnabayImg from '@/assets/echoes/arnabay.jpg'
import sayagiImg from '@/assets/echoes/sayagi.jpg'
import rianghopImg from '@/assets/echoes/rianghop.jpg'
import bloomeraImg from '@/assets/echoes/bloomera.jpg'

export interface Echo {
  id: string
  name: string
  rarity: Rarity
  concept: string
  origin: string
  color: string
  places: string[]
  image: string
}

export const ECHOES: Record<string, Echo> = {
  embuin: {
    id: 'embuin',
    name: 'Embuin',
    rarity: 'common',
    concept: 'Small droplet creature that forms from morning dew. Rolls through grass leaving glistening trails.',
    origin: 'embun (dew) + uin (teardrop sound)',
    color: '#7dd3fc',
    places: ['embuns-clearing', 'tall-grass-way'],
    image: embuinImg,
  },
  rumpuff: {
    id: 'rumpuff',
    name: 'Rumpuff',
    rarity: 'common',
    concept: 'A fluffy tuft of sentient grass that hops between hiding spots. Always found in clusters.',
    origin: 'rumput (grass) + puff',
    color: '#86efac',
    places: ['embuns-clearing', 'tall-grass-way'],
    image: rumpuffImg,
  },
  lebunyi: {
    id: 'lebunyi',
    name: 'Lebunyi',
    rarity: 'common',
    concept: 'A solitary, translucent bee-like Echo with silent wings. Hovers near wildflowers.',
    origin: 'lebah (bee) + sunyi (silent)',
    color: '#fde047',
    places: ['embuns-clearing'],
    image: lebunyiImg,
  },
  crikawn: {
    id: 'crikawn',
    name: 'Crikawn',
    rarity: 'common',
    concept: 'A melancholy cricket that sings at dawn. Its song fades like mist.',
    origin: 'cricket + dawn',
    color: '#a5b4fc',
    places: ['embuns-clearing', 'tall-grass-way'],
    image: crikawnImg,
  },
  tikidew: {
    id: 'tikidew',
    name: 'Tikidew',
    rarity: 'common',
    concept: 'A tiny dew-furred mouse that scurries through dewy grass, leaving ephemeral footprints.',
    origin: 'tikus (mouse) + dew',
    color: '#c4b5fd',
    places: ['tall-grass-way'],
    image: tikidewImg,
  },
  kelipsi: {
    id: 'kelipsi',
    name: 'Kelipsi',
    rarity: 'uncommon',
    concept: 'A faint firefly Echo that pulses with pale light. Harder to spot in daylight.',
    origin: 'kelip (flicker) + elipsis (fading)',
    color: '#fcd34d',
    places: ['tall-grass-way'],
    image: kelipsiImg,
  },
  arnabay: {
    id: 'arnabay',
    name: 'Arnabay',
    rarity: 'uncommon',
    concept: 'A breeze-touched rabbit with wind-swept fur that phases through tall grass.',
    origin: 'arnab (rabbit) + bayu (breeze)',
    color: '#a7f3d0',
    places: ['embuns-clearing', 'tall-grass-way'],
    image: arnabayImg,
  },
  sayagi: {
    id: 'sayagi',
    name: 'Sayagi',
    rarity: 'uncommon',
    concept: 'A moth with dawn-colored wings. Only appears when the air is still.',
    origin: 'sayap (wing) + pagi (morning)',
    color: '#fda4af',
    places: ['tall-grass-way'],
    image: sayagiImg,
  },
  rianghop: {
    id: 'rianghop',
    name: 'Rianghop',
    rarity: 'rare',
    concept: 'A joyful frog Echo with iridescent green skin. Leaps between dewdrops without breaking them.',
    origin: 'riang (cheerful) + hop',
    color: '#4ade80',
    places: ['embuns-clearing'],
    image: rianghopImg,
  },
  bloomera: {
    id: 'bloomera',
    name: 'Bloomera',
    rarity: 'rare',
    concept: 'A flower spirit that blooms only to those who wait. Petals shimmer like captured sunrise.',
    origin: 'bloom + era (waiting/time)',
    color: '#f9a8d4',
    places: ['tall-grass-way'],
    image: bloomeraImg,
  },
}

export const ECHO_LIST = Object.values(ECHOES)
export const ECHO_IDS = Object.keys(ECHOES) as (keyof typeof ECHOES)[]
